<template>
    <div class="dashboard" :class="{ 'loading' : loading }">
        <span class="loading-spinner" v-if="loading"></span>
        <div class="application-stage application-start">
            <div class="expander-box">
                <h2>Before you start, note the following:</h2>
                <div class="content active">
                    <ul class="flex">
                        <li><img :src="this.images_path + '/icon-user.svg'" /> You must be an employee of Morrisons</li>
                        <li><img :src="this.images_path + '/icon-uk-resident.svg'" /> You must be a UK resident</li>
                        <li><img :src="this.images_path + '/icon-hash.svg'" /> Ensure you have your employee ID number to hand to complete the form</li>
                    </ul>
                </div>
            </div>
            <div class="expander-box">
                <h2>Do you want to pay to cover a family member?</h2>
                <div class="content active" v-html="fm_cover_details"></div>
            </div>
            <div class="expander-box highlight-box">
                <h2>To start your application, choose your level of cover from the table below</h2>
                <div class="content active" v-html="select_cover_details"></div>
            </div>

            <div class="mobile-tabs">
                <p>Choose a level of cover to view more details</p>
                <ul>
                    <li><a class="tab-level-link active" data-level="1">2</a></li>
                    <li><a class="tab-level-link" data-level="2">3</a></li>
                    <li><a class="tab-level-link" data-level="3">4</a></li>
                    <li><a class="tab-level-link" data-level="4">5</a></li>
                    <li><a class="tab-level-link" data-level="5">6</a></li>
                </ul>
            </div>
            <payroll-table :benefits="benefits"></payroll-table>

            <p class="premium-tax-note"><small>Premiums include insurance premium tax (IPT).</small></p>

            <div class="mobile-tabs">
                <p>Choose a level of cover to view more details</p>
                <ul>
                    <li><a class="tab-level-link active" data-level="1">2</a></li>
                    <li><a class="tab-level-link" data-level="2">3</a></li>
                    <li><a class="tab-level-link" data-level="3">4</a></li>
                    <li><a class="tab-level-link" data-level="4">5</a></li>
                    <li><a class="tab-level-link" data-level="5">6</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState, mapMutations } from 'vuex';
    import PayrollTableHeader from '../select-cover/table/table-header';
    import PayrollTable from '../select-cover/table/table';
    import { EventBus } from './../../../helpers/bus';

    export default {
        props:[],
        components:{
            PayrollTableHeader,
            PayrollTable
        },
        computed: {
            ...mapState(
                [ 'stages', 'application', 'errors', 'prices' ],
            )
        },
        created() {
            let vm = this,
                benefits_api_url = '/wp-json/sovereign/v1/get-benefits',
                options_api_url = '/wp-json/acf/v3/options/option';

            axios.get(benefits_api_url)
                .then(response => {
                    if( response.status == '200' ) {
                        vm.benefits = response.data;
                    }
                })
                .catch( error => { });

            axios.get(options_api_url)
                .then(response => {
                    if( response.status == '200' ) {
                        vm.select_cover_details = response.data.acf.app_select_cover_details;
                        vm.fm_cover_details = response.data.acf.fm_cover_details;

                        setTimeout( function(){
                            window.scrollTo(0,0);
                            vm.loading = false;
                        }, 500);
                    }
                })
                .catch( error => { });
        },
        mounted() {
            let vm = this;
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);

            setTimeout( function(){
                window.scrollTo(0,0);
                vm.loading = false;
            }, 500);

            vm.$ga.page({
                page: '/',
                title: 'Apply Now',
                location: window.location.origin + '/'
            });

            if( params.get("stage") ) {
                history.pushState(null, 'Apply Now', '/');
            }
        },
        methods: {
            // updatePaymentType( payment_type ) {
            //     let vm = this;

            //     vm.$store.dispatch( 'updatePaymentType', payment_type );
            //     vm.$store.dispatch( 'updateStage', [ 'select-cover', true ] );

            //     history.pushState(null, 'Select Cover', '/?stage=select-cover');
            //     EventBus.$emit('updateStageURL');
            // }
        },
        data () {
            return {
                benefits: false,
                loading: true,
                select_cover_details: '',
                fm_cover_details: ''
            }
        }
    }
</script>
